import React, { useState } from 'react';
import { DatabaseIcon, FileTextIcon, CheckSquareIcon, UploadIcon, DownloadIcon, RefreshCwIcon, TrashIcon, AlertCircleIcon, ClockIcon, DollarSignIcon, ServerIcon, LayersIcon, HomeIcon, UserIcon, MapPinIcon, HashIcon, PlusIcon, FilterIcon, ArchiveIcon, HardDriveIcon } from 'lucide-react';
export const DataManagementSettings = () => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  return <div className="space-y-8" data-id="element-733">
      {/* Core Record Management */}
      <div className="border-b border-gray-200 pb-8" data-id="element-734">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-735">
          Core Record Management
        </h3>
        <div className="space-y-6" data-id="element-736">
          {/* Record Type Configuration */}
          <div data-id="element-737">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-738">
              Record Type Configuration
            </label>
            <div className="space-y-4" data-id="element-739">
              {[{
              type: 'Jurisdictions',
              icon: LayersIcon,
              fields: ['Code', 'Name', 'Level', 'Parent'],
              status: 'Active',
              count: 245
            }, {
              type: 'Properties',
              icon: HomeIcon,
              fields: ['Parcel ID', 'Address', 'Type', 'Zone'],
              status: 'Active',
              count: 12567
            }, {
              type: 'Taxpayers',
              icon: UserIcon,
              fields: ['TIN', 'Name', 'Type', 'Contact'],
              status: 'Active',
              count: 8934
            }].map(record => <div key={record.type} className="border border-gray-200 rounded-lg p-4" data-id="element-740">
                  <div className="flex items-center justify-between mb-3" data-id="element-741">
                    <div className="flex items-center" data-id="element-742">
                      <record.icon className="h-5 w-5 text-gray-400 mr-2" data-id="element-743" />
                      <div data-id="element-744">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-745">
                          {record.type}
                        </h4>
                        <p className="text-xs text-gray-500" data-id="element-746">
                          {record.count} records
                        </p>
                      </div>
                    </div>
                    <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full" data-id="element-747">
                      {record.status}
                    </span>
                  </div>
                  <div className="space-y-3" data-id="element-748">
                    <div className="flex flex-wrap gap-2" data-id="element-749">
                      {record.fields.map(field => <span key={field} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-750">
                          {field}
                        </span>)}
                    </div>
                    <div className="flex justify-end space-x-2" data-id="element-751">
                      <button className="text-sm text-gray-600 hover:text-gray-900" data-id="element-752">
                        Configure
                      </button>
                      <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-753">
                        Manage Fields
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Hierarchy Rules */}
          <div data-id="element-754">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-755">
              Hierarchy Validation Rules
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-756">
              <div className="space-y-4" data-id="element-757">
                <div className="flex items-center justify-between" data-id="element-758">
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-759">
                    Level Dependencies
                  </h4>
                  <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-760">
                    Edit Rules
                  </button>
                </div>
                <div className="space-y-2" data-id="element-761">
                  {[{
                  level: 'Region',
                  requires: 'None',
                  code: 'R-###'
                }, {
                  level: 'Zone',
                  requires: 'Region',
                  code: 'Z-###'
                }, {
                  level: 'Woreda',
                  requires: 'Zone',
                  code: 'W-###'
                }, {
                  level: 'Kebele',
                  requires: 'Woreda',
                  code: 'K-###'
                }].map(level => <div key={level.level} className="flex items-center justify-between text-sm" data-id="element-762">
                      <div className="flex items-center" data-id="element-763">
                        <LayersIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-764" />
                        <span className="text-gray-900" data-id="element-765">{level.level}</span>
                      </div>
                      <div className="flex items-center space-x-4" data-id="element-766">
                        <span className="text-gray-500" data-id="element-767">
                          Requires: {level.requires}
                        </span>
                        <span className="text-gray-500" data-id="element-768">
                          Format: {level.code}
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Data Validation Rules */}
      <div className="border-b border-gray-200 pb-8" data-id="element-769">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-770">
          Data Validation Rules
        </h3>
        <div className="space-y-6" data-id="element-771">
          {/* Parcel ID Validation */}
          <div data-id="element-772">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-773">
              Parcel ID Format Rules
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-774">
              <div className="space-y-4" data-id="element-775">
                <div className="grid grid-cols-2 gap-4" data-id="element-776">
                  <div data-id="element-777">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-778">
                      Format Pattern
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="[A-Z]{2}-\d{4}-\d{6}" value="[A-Z]{2}-\d{4}-\d{6}" data-id="element-779" />
                  </div>
                  <div data-id="element-780">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-781">
                      Example
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm bg-gray-50" value="AA-2024-123456" readOnly data-id="element-782" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-783">
                  <div className="flex items-center" data-id="element-784">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" defaultChecked data-id="element-785" />
                    <label className="ml-2 text-sm text-gray-600" data-id="element-786">
                      Auto-generate sequential numbers
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-787">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" defaultChecked data-id="element-788" />
                    <label className="ml-2 text-sm text-gray-600" data-id="element-789">
                      Enforce uniqueness check
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Address Validation */}
          <div data-id="element-790">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-791">
              Address Validation Service
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-792">
              <div className="space-y-4" data-id="element-793">
                <div className="flex items-center justify-between" data-id="element-794">
                  <div className="flex items-center" data-id="element-795">
                    <MapPinIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-796" />
                    <h4 className="text-sm font-medium text-gray-900" data-id="element-797">
                      Address Verification API
                    </h4>
                  </div>
                  <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full" data-id="element-798">
                    Connected
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-799">
                  <div data-id="element-800">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-801">
                      Service Provider
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-802">
                      <option data-id="element-803">Ethiopian Postal Service</option>
                      <option data-id="element-804">Custom Service</option>
                    </select>
                  </div>
                  <div data-id="element-805">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-806">
                      Verification Level
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-807">
                      <option data-id="element-808">Full Verification</option>
                      <option data-id="element-809">Basic Check</option>
                      <option data-id="element-810">Format Only</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Custom Field Validation */}
          <div data-id="element-811">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-812">
              Custom Field Validation Rules
            </label>
            <div className="space-y-4" data-id="element-813">
              {[{
              field: 'Construction Year',
              type: 'Number',
              rules: ['Min: 1900', 'Max: Current Year', 'Required']
            }, {
              field: 'Property Usage',
              type: 'Dropdown',
              rules: ['From Master List', 'Required']
            }, {
              field: 'Special Notes',
              type: 'Text',
              rules: ['Max Length: 500', 'No Special Chars']
            }].map(field => <div key={field.field} className="border border-gray-200 rounded-lg p-4" data-id="element-814">
                  <div className="flex items-center justify-between mb-2" data-id="element-815">
                    <div data-id="element-816">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-817">
                        {field.field}
                      </h4>
                      <p className="text-xs text-gray-500" data-id="element-818">
                        Type: {field.type}
                      </p>
                    </div>
                    <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-819">
                      Edit Rules
                    </button>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-820">
                    {field.rules.map((rule, index) => <span key={index} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-821">
                        {rule}
                      </span>)}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
      {/* Import/Export Configuration */}
      <div className="border-b border-gray-200 pb-8" data-id="element-822">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-823">
          Import/Export Configuration
        </h3>
        <div className="space-y-6" data-id="element-824">
          {/* Data Mappings */}
          <div data-id="element-825">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-826">
              Data Import/Export Mappings
            </label>
            <div className="space-y-4" data-id="element-827">
              {[{
              name: 'Property Bulk Import',
              format: 'Excel',
              mappings: ['Parcel ID', 'Address', 'Owner', 'Value']
            }, {
              name: 'Taxpayer Import',
              format: 'CSV',
              mappings: ['TIN', 'Name', 'Contact', 'Type']
            }, {
              name: 'Payment Export',
              format: 'XML',
              mappings: ['Transaction ID', 'Amount', 'Date', 'Status']
            }].map(template => <div key={template.name} className="border border-gray-200 rounded-lg p-4" data-id="element-828">
                  <div className="flex items-center justify-between mb-3" data-id="element-829">
                    <div data-id="element-830">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-831">
                        {template.name}
                      </h4>
                      <p className="text-xs text-gray-500" data-id="element-832">
                        Format: {template.format}
                      </p>
                    </div>
                    <div className="flex space-x-2" data-id="element-833">
                      <button className="text-sm text-gray-600 hover:text-gray-900" data-id="element-834">
                        Edit
                      </button>
                      <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-835">
                        Download Template
                      </button>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-836">
                    {template.mappings.map(field => <span key={field} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-837">
                        {field}
                      </span>)}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
      {/* Payment Rules & Thresholds */}
      <div className="border-b border-gray-200 pb-8" data-id="element-838">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-839">
          Payment Rules & Thresholds
        </h3>
        <div className="space-y-6" data-id="element-840">
          {/* Amount Thresholds */}
          <div data-id="element-841">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-842">
              Payment Amount Rules
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-843">
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-844">
                <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-845">
                  Minimum Amounts
                </h4>
                <div className="space-y-3" data-id="element-846">
                  <div className="flex items-center justify-between" data-id="element-847">
                    <span className="text-sm text-gray-600" data-id="element-848">
                      Minimum Tax Amount
                    </span>
                    <input type="number" className="w-32 px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="100" data-id="element-849" />
                  </div>
                  <div className="flex items-center justify-between" data-id="element-850">
                    <span className="text-sm text-gray-600" data-id="element-851">
                      Minimum Fee Amount
                    </span>
                    <input type="number" className="w-32 px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="50" data-id="element-852" />
                  </div>
                </div>
              </div>
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-853">
                <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-854">
                  Increase Caps
                </h4>
                <div className="space-y-3" data-id="element-855">
                  <div className="flex items-center justify-between" data-id="element-856">
                    <span className="text-sm text-gray-600" data-id="element-857">
                      Annual Tax Increase Cap
                    </span>
                    <input type="number" className="w-32 px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="15" data-id="element-858" />
                  </div>
                  <div className="flex items-center justify-between" data-id="element-859">
                    <span className="text-sm text-gray-600" data-id="element-860">
                      Fee Increase Cap
                    </span>
                    <input type="number" className="w-32 px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="10" data-id="element-861" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Payment Options */}
          <div data-id="element-862">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-863">
              Payment Options Configuration
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-864">
              <div className="space-y-4" data-id="element-865">
                <div className="flex items-center justify-between" data-id="element-866">
                  <div className="flex items-center" data-id="element-867">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" defaultChecked data-id="element-868" />
                    <label className="ml-2 text-sm text-gray-600" data-id="element-869">
                      Allow Partial Payments
                    </label>
                  </div>
                  <input type="number" className="w-32 px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="Minimum %" data-id="element-870" />
                </div>
                <div className="flex items-center justify-between" data-id="element-871">
                  <div className="flex items-center" data-id="element-872">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" defaultChecked data-id="element-873" />
                    <label className="ml-2 text-sm text-gray-600" data-id="element-874">
                      Allow Overpayment
                    </label>
                  </div>
                  <input type="number" className="w-32 px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="Maximum %" data-id="element-875" />
                </div>
                <div className="flex items-center justify-between" data-id="element-876">
                  <div className="flex items-center" data-id="element-877">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" defaultChecked data-id="element-878" />
                    <label className="ml-2 text-sm text-gray-600" data-id="element-879">
                      Auto-apply Excess to Next Bill
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Grace Periods */}
          <div data-id="element-880">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-881">
              Grace Period Settings
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-882">
              <div className="space-y-4" data-id="element-883">
                {[{
                type: 'Late Payment',
                period: '15 days',
                penalty: '2%'
              }, {
                type: 'Non-Declaration',
                period: '30 days',
                penalty: '5%'
              }, {
                type: 'Amendment Period',
                period: '45 days',
                penalty: 'None'
              }].map(grace => <div key={grace.type} className="flex items-center justify-between" data-id="element-884">
                    <span className="text-sm text-gray-900" data-id="element-885">{grace.type}</span>
                    <div className="flex items-center space-x-4" data-id="element-886">
                      <input type="text" className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm" value={grace.period} data-id="element-887" />
                      <input type="text" className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm" value={grace.penalty} data-id="element-888" />
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Data Retention & Backup */}
      <div className="pt-8" data-id="element-889">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-890">
          Data Retention & Backup
        </h3>
        <div className="space-y-6" data-id="element-891">
          {/* Backup Configuration */}
          <div data-id="element-892">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-893">
              Backup Configuration
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-894">
              <div className="space-y-4" data-id="element-895">
                <div className="grid grid-cols-2 gap-4" data-id="element-896">
                  <div data-id="element-897">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-898">
                      Storage Location
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-899">
                      <option data-id="element-900">Local Server</option>
                      <option data-id="element-901">Cloud Storage</option>
                      <option data-id="element-902">Remote Server</option>
                    </select>
                  </div>
                  <div data-id="element-903">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-904">
                      Backup Frequency
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-905">
                      <option data-id="element-906">Daily</option>
                      <option data-id="element-907">Weekly</option>
                      <option data-id="element-908">Monthly</option>
                    </select>
                  </div>
                </div>
                <div data-id="element-909">
                  <label className="block text-xs text-gray-500 mb-1" data-id="element-910">
                    Retention Period
                  </label>
                  <div className="grid grid-cols-2 gap-4" data-id="element-911">
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-912">
                      <option data-id="element-913">Daily Backups: 7 days</option>
                      <option data-id="element-914">Weekly Backups: 4 weeks</option>
                      <option data-id="element-915">Monthly Backups: 12 months</option>
                    </select>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-916">
                      <option data-id="element-917">Yearly Backups: 7 years</option>
                      <option data-id="element-918">Yearly Backups: 10 years</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Data Retention */}
          <div data-id="element-919">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-920">
              Data Retention Policy
            </label>
            <div className="space-y-4" data-id="element-921">
              {[{
              type: 'Transaction Records',
              active: '2 years',
              archive: '7 years',
              action: 'Archive'
            }, {
              type: 'Property History',
              active: '5 years',
              archive: '10 years',
              action: 'Archive'
            }, {
              type: 'Audit Logs',
              active: '1 year',
              archive: '5 years',
              action: 'Delete'
            }].map(policy => <div key={policy.type} className="border border-gray-200 rounded-lg p-4" data-id="element-922">
                  <div className="flex items-center justify-between mb-3" data-id="element-923">
                    <h4 className="text-sm font-medium text-gray-900" data-id="element-924">
                      {policy.type}
                    </h4>
                    <span className="text-xs text-gray-500" data-id="element-925">
                      Action: {policy.action}
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-926">
                    <span className="text-gray-600" data-id="element-927">
                      Active: {policy.active}
                    </span>
                    <span className="text-gray-600" data-id="element-928">
                      Archive: {policy.archive}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};